import { enableProdMode } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';
import { SmartWidgetElementComponent } from '@app/smart-widget-element/smart-widget-element.component';
import { appConfig } from '@app/app.config';
import { environment } from '@environments/environment';
import { register } from 'swiper/element/bundle';

// One entry for both delivery modes: registers the custom element only. Our index pages
// embed the tag with `iframe-mode`; integrator pages embed the bare tag with attributes.
// Sentry init lives in the wrapper (mode-aware — the WC variant must not observe the host page).
if (environment?.production) {
  enableProdMode();
}

register();

(async () => {
  const app = await createApplication(appConfig);

  const smartWidgetElement = createCustomElement(SmartWidgetElementComponent, {
    injector: app.injector,
  });
  customElements.define(environment.smartWidgetElementTag, smartWidgetElement);
})().catch((error) => {
  // Surface a failed bootstrap (e.g. another Angular app already owns the platform, or the
  // element tag was already defined) to the console instead of silently rendering nothing.
  console.error(`[SmartWidget] Failed to initialise the <${environment.smartWidgetElementTag}> web component:`, error);
});
